import React from 'react'
import { Form } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { ErrorMessage } from '@hookform/error-message';

export const InputField = ( props ) => {

    // Attributes "type", "required" and "autoComplete" has default values in case doesn't recieving in "props" at component invocation.
    const { 
        name, 
        label, 
        type = "text", 
        placeholder = "", 
        // value, 
        autoComplete = "off", // "off" es el valor por defecto si no se envía el atributo
        // onChange, 
        // required = false,
        // onBlur,
        disabled = false, 
        useFormRegister,
        errors = {}, // "errors" attribute shouldn't be absent most of the times
    } = props;
    
    return ( 

                // value={ value } 
                // onChange={ onChange }
                // onBlur={ onBlur }
                // required={ required }

        <Form.Group controlId={ name }>
            <Form.Label>{ label }</Form.Label>
            <Form.Control  
                type={ type }
                name={ name }
                placeholder={ placeholder } 
                disabled={disabled}
                // value={ register.given_name } 
                autoComplete={ autoComplete } 
                {...useFormRegister}
                // onChange={ onChange }
                // {...register("given_name", fieldValidations)}
                // onBlur={ onBlur }  
            />
            <ErrorMessage errors={errors} name={name} as={<p className='error-message'/>} />
        </Form.Group> 

    )
}

// PropTypes is necesary in order to obtain "context" in main function attribute.
InputField.contextTypes = {
    t: PropTypes.func
}

export default InputField;